import React, {useState} from 'react';
import { DndProvider } from 'react-dnd-multi-backend';
import HTML5toTouch from 'react-dnd-multi-backend/dist/esm/HTML5toTouch';
import { FormattedMessage } from "react-intl";
import { Header } from "./page/Header";
import { Footer } from "./page/Footer";
import { Advert } from "./components/Advert";
import { Game } from "./page/Game";
import { Games } from "./assets/gameConfig";

export const App = () => {
    const gameConfig = Games;
    const [resetGame, setReset] = useState(false);
    const [gameId, changeGame] = useState(1);

  return (
    <div className="App">
        <Header games={gameConfig} currentGame={gameId} onChangeGame={changeGame} onReset={()=>{setReset(true)}}/>
        <DndProvider options={HTML5toTouch}>
            <div id="content" className="container-fluid">
              <Game
                  cardConfig={gameConfig.cardConfig}
                  config={gameConfig.items.filter((item) => item.id === gameId)[0]}
                  reset={resetGame}
                  onResetDone={()=>setReset(false)}
              />
            </div>
        </DndProvider>

        <div id="secondary" className="container-fluid">
            <Advert headline="advert.buyCards.heading" text="advert.buyCards.text" btnUrl="advert.buyCards.btn.url" btnText="advert.buyCards.btn" btnIcon="icon-monster-shop" />
            <Advert headline="advert.academy.heading" text="advert.academy.text" btnUrl="advert.academy.btn.url" btnText="advert.academy.btn" btnIcon="" />
        </div>
        <Footer />
        <div id="warning-message">
            <FormattedMessage id="message.pageOrientation" />
        </div>
    </div>
  );
};

